import constant from "@/utils/constant";
import { i18n } from "@/utils/i18n";
import { Divider, Grid2, Typography } from "@mui/material";
import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Forms } from "@/types/form";
import Comment from "../fields/comment";
import Status from "../fields/status";
import BigNumber from "bignumber.js";
import { formatNegativeAmount } from "@/utils/helpers";

interface Props {
    variant: "incomings" | "outgoings";
}

const Categories: React.FC<Props> = ({ variant }) => {
    const { CURRENCIES } = constant;

    const { control } = useFormContext<Forms["Report"]>();
    const { fields } = useFieldArray({ name: variant, control });

    const total = fields.reduce((acc, current) => {
        return acc.plus(current.amount);
    }, new BigNumber(0));

    return (
        <Grid2 container padding="0px 60px" rowSpacing={1}>
            <Grid2 size={12}>
                <Typography variant="h5" fontWeight="bold">
                    {i18n.t(variant)}
                </Typography>
            </Grid2>
            <Grid2 container size={12} columnSpacing={4} direction="row">
                <Grid2 size={4}>
                    <Typography variant="h6" fontWeight="bold">
                        {i18n.t("category")}
                    </Typography>
                </Grid2>
                <Grid2 size={2}>
                    <Typography variant="h6" fontWeight="bold" textAlign="right">
                        {i18n.t("amount")}
                    </Typography>
                </Grid2>
                <Grid2 size={4}>
                    <Typography variant="h6" fontWeight="bold" textAlign="left">
                        {i18n.t("comment")}
                    </Typography>
                </Grid2>
                <Grid2 size={2}>
                    <Typography variant="h6" fontWeight="bold" textAlign="center">
                        {i18n.t("status")}
                    </Typography>
                </Grid2>
                <Grid2 size={12}>
                    <Divider />
                </Grid2>
            </Grid2>
            {fields.map(({ id, ...field }, index) => {
                const { amount, description } = field;

                return (
                    <Grid2
                        key={id}
                        container
                        size={12}
                        columnSpacing={4}
                        rowSpacing={1}
                        direction="row"
                        alignItems="center"
                    >
                        <Grid2 size={4}>
                            <Typography variant="subtitle1">{description}</Typography>
                        </Grid2>
                        <Grid2 size={2}>
                            <Typography variant="subtitle1" textAlign="right">
                                {variant === "incomings"
                                    ? CURRENCIES.KRONA.format(amount)
                                    : formatNegativeAmount(amount)}
                            </Typography>
                        </Grid2>
                        <Grid2 size={4}>
                            <Comment index={index} variant={variant} />
                        </Grid2>
                        <Grid2 size={2} display="flex" alignItems="center" justifyContent="center">
                            <Status index={index} variant={variant} />
                        </Grid2>
                        <Grid2 size={12}>
                            <Divider />
                        </Grid2>
                    </Grid2>
                );
            })}
            <Grid2 container size={12} columnSpacing={4} direction="row" alignItems="center">
                <Grid2 size={4}>
                    <Typography variant="h6" fontWeight="bold">
                        {i18n.t("amount")} {variant == "incomings" ? "B" : "C"}
                    </Typography>
                </Grid2>
                <Grid2 size={2}>
                    <Typography variant="h6" textAlign="right" fontWeight="bold">
                        {variant === "outgoings"
                            ? formatNegativeAmount(total.toNumber())
                            : CURRENCIES.KRONA.format(total.toNumber())}
                    </Typography>
                </Grid2>
            </Grid2>
        </Grid2>
    );
};

export default Categories;
